import { render, staticRenderFns } from "./cefloreco-banner-2.vue?vue&type=template&id=ddc3cecc&scoped=true&"
import script from "./cefloreco-banner-2.vue?vue&type=script&lang=js&"
export * from "./cefloreco-banner-2.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-banner-2.vue?vue&type=style&index=0&id=ddc3cecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3cecc",
  null
  
)

export default component.exports